import { constants } from "../constants/constants";
import Money from './money';

const calcOneTimes = (rows, oneTimeKeys) => {
    const oneTimeTotals = {};

    for (const row of rows) {
        oneTimeKeys.forEach(key => {
            if (!row[key]) {
                return;
            }

            if (!oneTimeTotals[key]) {
                oneTimeTotals[key] = {
                    paid: {
                        value: 0,
                        currency: row[key].paid.currency,
                    },
                    total: {
                        value: 0,
                        currency: row[key].total.currency,
                    },
                    scheduled_to_pay: {
                        value: 0,
                        currency: row[key].paid.currency,
                    }
                }
            }
            oneTimeTotals[key].paid.value += row[key].paid.value;
            oneTimeTotals[key].total.value += row[key].total.value;
            oneTimeTotals[key].scheduled_to_pay.value += row[key].scheduled_to_pay.value;
        });
    }

    return oneTimeTotals;
}

export const createTotalRow = (rows = [], currency) => {
    let totalRow = {
        "total": {
            "charged": {
                "value": 0,
                "currency": currency
            },
            "debt": {
                "value": 0,
                "currency": currency
            },
            "future": {
                "value": 0,
                "currency": currency
            }
        },
    };

    for (const month of Object.values(constants.MonthsToText)) {
        totalRow[month] = {
            "total": {
                "value": 0,
                "currency": currency
            },
            "paid": {
                "value": 0,
                "currency": currency
            },
            "scheduled_to_pay": {
                "value": 0,
                "currency": currency
            },
        }
    }

    const oneTimeKeysObj = {};
    for (const row of rows) {
        Object.keys(row).forEach(key => {
            if (key.startsWith('one_time_')) {
                oneTimeKeysObj[key] = true;
            }
        });
    }
    const oneTimeKeys = Object.keys(oneTimeKeysObj);
    const oneTimeTotals = calcOneTimes(rows, oneTimeKeys);

    for (const row of rows) {
        if (row?.total?.charged.value) totalRow.total.charged.value += +row?.total?.charged.value;
        if (row?.total?.debt.value) totalRow.total.debt.value += +row?.total?.debt.value;
        if (row?.total?.future.value) totalRow.total.future.value += +row?.total?.future.value;

        for (const monthInt of constants.months) {
            const currentMonth = constants.MonthsToText[monthInt];
            if (row[constants.MonthsToText[monthInt]]) {
                totalRow[currentMonth].total.value += +row[currentMonth]?.total.value;
                totalRow[currentMonth].paid.value += +row[currentMonth]?.paid.value > +row[currentMonth]?.total.value ? +row[currentMonth]?.total.value : +row[currentMonth]?.paid.value;
                totalRow[currentMonth].scheduled_to_pay.value += +row[currentMonth]?.scheduled_to_pay.value;
            }
        }

        for (const monthInt of constants.months) {
            if (row[constants.MonthsToText[monthInt]]) {
                totalRow[constants.MonthsToText[monthInt]].total.value = Money.roundNumber(totalRow[constants.MonthsToText[monthInt]].total.value, 2);
                totalRow[constants.MonthsToText[monthInt]].paid.value = Money.roundNumber(totalRow[constants.MonthsToText[monthInt]].paid.value, 2);
                totalRow[constants.MonthsToText[monthInt]].scheduled_to_pay.value = Money.roundNumber(totalRow[constants.MonthsToText[monthInt]].scheduled_to_pay.value, 2);
            }
        }
    }

    return {...totalRow, ...oneTimeTotals};
};

export const createPercentageRow = (totalRow, currency) => {
    let percantageRow = {};

    const oneTimeKeysObj = {};
    Object.keys(totalRow).forEach(key => {
        if (key.startsWith('one_time_')) {
            oneTimeKeysObj[key] = true;
        }
    });
    const oneTimeKeys = Object.keys(oneTimeKeysObj);
    const oneTimeTotals = calcOneTimes([totalRow], oneTimeKeys);

    for (const oneTimeKey of oneTimeKeys) {
        const paidPercents = oneTimeTotals[oneTimeKey].total.value ? (oneTimeTotals[oneTimeKey].paid.value / oneTimeTotals[oneTimeKey].total.value) * 100 : 0;
        const totalPercents = oneTimeTotals[oneTimeKey].total.value ? 100 : 0;
        oneTimeTotals[oneTimeKey].paid.value = Math.floor(paidPercents);
        oneTimeTotals[oneTimeKey].paid.isPercent = true;
        oneTimeTotals[oneTimeKey].total.value = Math.floor(totalPercents);
        oneTimeTotals[oneTimeKey].total.isPercent = true;
    }

    for (const month of Object.values(constants.MonthsToText)) {
        percantageRow[month] = {
            "total": {
                "value": 0,
                "currency": currency
            },
            "paid": {
                "value": 0,
                "currency": currency
            },
            "scheduled_to_pay": {
                "value": 0,
                "currency": currency
            },
        }
    }

    for (const monthInt of constants.months) {
        if (totalRow[constants.MonthsToText[monthInt]]) {
            const monthInfo = totalRow[constants.MonthsToText[monthInt]];
            const paid = monthInfo?.paid?.value/monthInfo.total?.value*100;
            let percentageNum;
            if (isNaN(paid)) percentageNum = 0;
            else if (paid > 100) percentageNum = 100;
            else percentageNum = paid;
            percantageRow[constants.MonthsToText[monthInt]].paid.value = percentageNum;

            let percantage;
            const isTotalPaymentZero = totalRow[constants.MonthsToText[monthInt]].total.value === 0 || !totalRow[constants.MonthsToText[monthInt]].total.value;
            if (isTotalPaymentZero) percantage = '0%';
            else percantage = '100%'
            percantageRow[constants.MonthsToText[monthInt]].total.value = percantage;
        }
    }

    for (const monthInt of constants.months) {
        if (percantageRow[constants.MonthsToText[monthInt]]) {
            percantageRow[constants.MonthsToText[monthInt]].paid.value = `${Math.floor(percantageRow[constants.MonthsToText[monthInt]].paid.value)}%`;
        }
    }

    return {...percantageRow, ...oneTimeTotals};
};
